import yup from "../../../../../../utils/yup-extended";
import {
  createSessionBasicFormStepFormValidationSchema,
  CreateSessionBasicFormStepFormValues,
} from "../../../../createService/multi-step/basic-form/schema-validation";
import {BundleSessionSessionPeriodFormFieldsType} from "../../../../../../components/offering-form/session-bundle/bundle/session-period/types";

export const createBundleBasicFormStepFormValidationSchema =
  createSessionBasicFormStepFormValidationSchema.shape({
    numberOfSessions: yup.string().trim().required("Number of sessions is required"),
    bookingInterval: yup.string().trim().required("Booking interval is required"),
  });

export type CreateBundleBasicFormStepFormValues = CreateSessionBasicFormStepFormValues &
  BundleSessionSessionPeriodFormFieldsType;
